export default __webpack_public_path__ + "static/media/TARATITLE.65290c85.png";